/**
 * Created by fers on 05.02.16.
 */
import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {injectIntl, defineMessages} from 'react-intl';

import types from '../../common/model-api/types';
import urlMapping from '../app/URLMapping';

import Editor from '../fw/Editor.react';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';

const messages = defineMessages({
    title: {id: 'flowEdit.title', 'defaultMessage': 'Editing flow'},
	save: {id: 'flowEdit.save', 'defaultMessage': 'Save custom name'}
});

class FlowEdit extends React.Component {

    static propTypes = {
        intl: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
    };
    typeName = 'flows';

    constructor() {
        super();
    }

    render() {
        let data = this.props.user.organisation.flow;
        let type = types[this.typeName];

        return (
            <AppPanel breadcrumbParams={[
                {type, data},
                {type: types['organisations'], data: this.props.user.organisation}]
            } title={this.props.intl.formatMessage(messages.title)}>
                <Editor
						buttonTitle={this.props.intl.formatMessage(messages.save)}
                        columns={{'name': {}, 'groupName': {}, 'description': {}}}
                        data={data}
                        fatQuery={Relay.QL `fragment on UpdateFlowPayload {
                            updatedNode {
                                id,
                                flowDef_id,
                                flowDef {
                                    id
                                },
                                organisation_id,
                                name,
                                groupName,
                                description,
                            },
                        }`}
                        metadata={type}
                        mutation={Relay.QL `mutation { updateFlow }`}
                        organisationId={data.organisation_id}
                        urlMapping={urlMapping}
                />
            </AppPanel>
        );
    }
}


export default Relay.createContainer(wrapNotFound(injectIntl(FlowEdit), (props) => {
    return props.user.organisation && props.user.organisation.flow;
}), {
    initialVariables: {
        organisationId: '',
        flowId: '',
    },
    prepareVariables (variables) {
		if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                    flow(id: $flowId) {
                        id,
                        realId,
                        organisation_id,
                        flowDef {
                            id,
                            name,
                        },
                        name,
                        groupName,
                        description,
                        enabled
                    }
                },
            }
        `,
    },
});
